import { gisBases } from "@/mocks/documentos";

export default function GisSourcesTable() {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground-900">Bases geográficas e cartográficas</h3>
        <div className="flex gap-2">
          <button className="px-3 py-1.5 text-xs font-semibold text-accent-700 bg-accent-50 rounded-lg hover:bg-accent-100 transition-colors whitespace-nowrap">
            <i className="ri-upload-cloud-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
            Importar base
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {gisBases.map((base) => {
          const isProblematic = !base.hasValidGeometry || !base.hasMetadata;

          return (
            <div key={base.id} className={`bg-white rounded-xl border ${isProblematic ? "border-warning-200" : "border-background-200/70"} p-4 hover:shadow-sm transition-shadow`}>
              <div className="flex items-start gap-3 mb-3">
                <div className={`w-10 h-10 rounded-lg ${base.hasValidGeometry ? "bg-accent-50" : "bg-warning-50"} flex items-center justify-center shrink-0`}>
                  <i className={`ri-map-2-line ${base.hasValidGeometry ? "text-accent-600" : "text-warning-600"} w-full h-full flex items-center justify-center text-lg`} />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold text-foreground-800 font-heading">{base.layerName}</div>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="px-1.5 py-0.5 text-[10px] font-medium bg-accent-50 text-accent-700 rounded border border-accent-100">{base.fileType}</span>
                    <span className="text-[11px] text-foreground-500">{base.geometry}</span>
                  </div>
                </div>
              </div>

              <div className="space-y-2 mb-3">
                <div className="flex justify-between text-xs">
                  <span className="text-foreground-400">SRID</span>
                  <span className="text-foreground-700 font-mono text-[11px]">{base.srid}</span>
                </div>
                <div className="flex justify-between text-xs">
                  <span className="text-foreground-400">Feições</span>
                  <span className="text-foreground-700 font-semibold">{base.featuresCount.toLocaleString("pt-BR")}</span>
                </div>
                <div className="flex justify-between text-xs">
                  <span className="text-foreground-400">Importação</span>
                  <span className="text-foreground-600">{base.importDate}</span>
                </div>
                {base.projectName && (
                  <div className="flex justify-between text-xs">
                    <span className="text-foreground-400">Projeto</span>
                    <span className="text-foreground-700 font-medium truncate max-w-[180px]">{base.projectName}</span>
                  </div>
                )}
              </div>

              <div className="flex items-center gap-2 mb-3">
                <span className={`px-2 py-0.5 text-[10px] font-medium rounded-full ${base.status === "Validado" ? "bg-primary-50 text-primary-700" : base.status === "Em revisão" ? "bg-caution-50 text-caution-700" : "bg-warning-50 text-warning-700"}`}>
                  {base.status}
                </span>
                {!base.hasMetadata && (
                  <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-warning-50 text-warning-700">
                    <i className="ri-alert-line w-3 h-3 inline-flex items-center justify-center mr-0.5" />
                    Sem metadados
                  </span>
                )}
                {!base.hasValidGeometry && (
                  <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-danger-50 text-danger-700">
                    <i className="ri-error-warning-line w-3 h-3 inline-flex items-center justify-center mr-0.5" />
                    Geometria inválida
                  </span>
                )}
              </div>

              <div className="flex items-center gap-2 pt-3 border-t border-background-100">
                <button className="flex-1 px-3 py-1.5 text-xs font-semibold text-accent-700 bg-accent-50 rounded-md hover:bg-accent-100 transition-colors whitespace-nowrap">
                  <i className="ri-map-pin-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                  Ver no mapa
                </button>
                <button className="px-3 py-1.5 text-xs font-semibold text-foreground-600 bg-background-50 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap">
                  <i className="ri-download-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                  Exportar
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}